module.exports = __webpack_public_path__ + "static/media/delete.2c3f4d6c.svg";